import { createContext, useContext } from 'react'

/**
 * The class a subtree's *portaled* surfaces (popovers, select menus, dialogs) should carry.
 *
 * Radix portals its overlays to `<body>`, so they land outside the DOM subtree that styles them and
 * come out with the app's default light theme however dark their trigger is. React context, unlike
 * CSS inheritance, does flow through a portal — so a subtree declares its surface class here and the
 * content components below paste it back on at the other end. Popover, select, dialog, dropdown and
 * tooltip all consume it, so one declaration themes every portaled surface in a subtree at once.
 *
 * Generic on purpose: the value is just a class, so `ui/` stays ignorant of who sets it. The
 * fullscreen editor passes `editor-dense` (see the planning-workspace route) so its comboboxes keep
 * their compact sizing; everywhere else leaves it unset and the surfaces keep the app theme.
 */
const PortalSurfaceClassNameContext = createContext<string | undefined>(undefined)

export const PortalSurfaceProvider = PortalSurfaceClassNameContext.Provider
export const usePortalSurfaceClassName = () => useContext(PortalSurfaceClassNameContext)
